function MethodTag({ method }) {
  return <span className={`method-tag method-${method.toLowerCase()}`}>{method}</span>;
}

export default function Sidebar({ catalog, activeId, onSelect, search, onSearchChange, isOpen }) {
  const filtered = catalog
    .map((group) => ({
      ...group,
      endpoints: group.endpoints.filter((ep) => {
        const term = search.trim().toLowerCase();
        if (!term) return true;
        return (
          ep.name.toLowerCase().includes(term) ||
          ep.summary.toLowerCase().includes(term) ||
          ep.path.toLowerCase().includes(term)
        );
      }),
    }))
    .filter((group) => group.endpoints.length > 0);

  return (
    <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
      <div className="sidebar-search">
        <input
          type="search"
          placeholder="Search endpoints…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search endpoints"
        />
      </div>

      <nav className="sidebar-nav">
        {filtered.length === 0 && <p className="sidebar-empty">No endpoints match your search.</p>}
        {filtered.map((group) => (
          <div className="sidebar-group" key={group.category}>
            <h3 className="sidebar-group-title">{group.category}</h3>
            <ul>
              {group.endpoints.map((ep) => (
                <li key={ep.id}>
                  <button
                    type="button"
                    className={`sidebar-link ${activeId === ep.id ? 'sidebar-link--active' : ''}`}
                    onClick={() => onSelect(ep.id)}
                  >
                    <MethodTag method={ep.method} />
                    <span className="sidebar-link-name">{ep.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
